<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title" *ngIf="inner_DeviceBehfa.id==0">فرم ثبت اطلاعات  تعمیر</h5>
      <h5 class="card-title" *ngIf="inner_DeviceBehfa.id!=0">اطلاعات  تعمیر 'کد {{inner_DeviceBehfa.id}}'</h5>



      <form >

        <button *ngIf="canEditMainForm && inner_DeviceBehfa.id==0" type="button" (click)="openModal_DeviceBehfa(templateDeviceBehfa)" class="btn btn-danger left"> انتخاب تجهیز بفها <i class="fa fa-building"></i> </button>

        <div  *ngIf="Data_Seleted_DeviceBehfa_Record.id>0">

          <div class="row">
            <div class="form-group col-md-3">
              <label for="exampleInputEmail1">Description</label>
              <input disabled type="text" class="form-control" value="{{Data_Seleted_DeviceBehfa_Record.description}}" >
            </div>
            <div class="form-group col-md-3">
              <label for="exampleInputEmail1">Manufacturer</label>
              <input disabled type="text" class="form-control" value="{{Data_Seleted_DeviceBehfa_Record.manufacturer}}" >
            </div>
            <div class="form-group col-md-3">
              <label for="exampleInputEmail1">model</label>
              <input disabled type="text" class="form-control" value="{{Data_Seleted_DeviceBehfa_Record.model}}" >
            </div>
            <div class="form-group col-md-3">
              <label for="exampleInputEmail1">Code BEHFA</label>
              <input disabled type="text" class="form-control" value="{{Data_Seleted_DeviceBehfa_Record.codeBEHFA}}" >
            </div>
          </div>

          <br/>
          <hr/>
          <br/>

          <div class="row" >
            <div class="form-group col-md-12">
              <label for="exampleInputEmail1">توضیحات </label>
              <textarea  type="text" [disabled]="!canEditMainForm" name="UserDsc" [(ngModel)]="UserDsc" class="form-control" placeholder="اینجا تایپ کنید ..." ></textarea>
            </div>

          </div>

          <br/>
          <hr/>
          <br/>

          <div class="row" *ngIf="canEditMainForm">
            <div class="form-group col-md-12">
              <label for="exampleInputEmail1"> بررسی کننده اولیه </label>
              <select [(ngModel)]="Selected_FirstUser" name="Selected_FirstUser" class="custom-select">
                <option value="0">انتخاب کنید</option>
                <option *ngFor="let item of DataList_FirstUser" [value]="item.id">{{item.title}}</option>
              </select>
            </div>

          </div>

          <br/>
          <hr/>
          <br/>

          <div *ngIf="canEditMainForm" class="row">
            <div class="form-group col-md-6">
              <label for="exampleInputEmail1">
                 فایل/های ضمیمه
                <button (click)="Remove_uploadImage1()"  type="button" *ngIf="UploadImageSrc"  class="btn  btn-danger" ><i class="fa  fa-times-rectangle"></i> </button>
              </label>
              <img *ngIf="InProccessing_Image1" src="assets/Loading.gif" style="width: 25px;" />
              <input *ngIf="!InProccessing_Image1" #file_Image1 (change)="uploadImage1(file_Image1.files)" type="file" class="form-control"  placeholder="اینجا تایپ کنید ...">
            </div>
          </div>

          <button  type="button" (click)="Add_uploadImage1()" [disabled]="!UploadImageSrc" class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افزودن ضمیمه </button>

          <br/>

          <div class="table-responsive" *ngIf="UploadImageSrc_List.length>0">
            <table class="mb-0 table table-bordered table-3 text-center table-striped">
              <thead style="background-color: #489b39; color: white;">
                <tr>
                  <th>#</th>
                  <th>فایل</th>

                  <th *ngIf="canEditMainForm" >امکانات</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of UploadImageSrc_List" >

                    <td>{{UploadImageSrc_List.indexOf(item)+1}}</td>
                    <td>
                      <img *ngIf="!item.includes('.pdf')" (click)="openModal(templateImage,item)" style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/DeviceBehfaRepair/{{item}}"/>
                    </td>
                    <td *ngIf="canEditMainForm">
                        <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                          <div class="btn-group" role="group">
                              <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  امکانات
                              </button>
                              <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                                  <a style="cursor: pointer;" (click)="UploadImageSrc_List_Delete(UploadImageSrc_List.indexOf(item))" class="dropdown-item" ><i class="fa fa-remove"></i> حذف </a>
                              </div>
                          </div>
                      </div>
                    </td>

                </tr>
              </tbody>
            </table>
          </div>


          <div *ngIf="inner_DeviceBehfa.id>0" >

            <br/>
            <hr/>
            <br/>

            <div class="row" >
              <div class="form-group col-md-9">
                <label for="exampleInputEmail1"> توضیحات بررسی اولیه </label>
                <textarea  type="text" [disabled]="!canAnswerFirst" name="UserDscFirst" [(ngModel)]="UserDscFirst" class="form-control" placeholder="اینجا تایپ کنید ..." ></textarea>
              </div>

              <div class="form-group col-md-3">
                <label for="exampleInputEmail1"> تاریخ و کاربر ثبت بررسی اولیه </label>
                <input disabled type="text" class="form-control" value="{{UserDateTimeFirst}} - {{UserUserNameFirst}}" >
              </div>
            </div>

          </div>

          <div *ngIf="inner_DeviceBehfa.id>0 && UserUserNameFirst && first_Answer!=false" >

            <br/>
            <hr/>
            <br/>

            <div class="row" >
              <div class="form-group col-md-6">
                <label for="exampleInputEmail1"> توضیحات بررسی ثانویه </label>
                <textarea  type="text" [disabled]="!canAnswerSecond" name="UserDscSecond" [(ngModel)]="UserDscSecond" class="form-control" placeholder="اینجا تایپ کنید ..." ></textarea>
              </div>

              <div class="form-group col-md-3" *ngIf="canAnswerSecond">
                <label for="exampleInputEmail1">پیمانکار </label>
                <select class="custom-select" (change)="ReadData_Contractor_Cusetomer()" [(ngModel)]="Selected_Contractor.id" name="Selected_Contractor" >
                  <option value="0">انتخاب کنید</option>
                  <option *ngFor="let item of DataList_Contractor" [value]="item.id">{{item.title}}</option>
                </select>
              </div>

              <div class="form-group col-md-3" *ngIf="canAnswerSecond">
                <label for="exampleInputEmail1">مشتری</label>
                <select class="custom-select" [(ngModel)]="Selected_Contractor_Customer.id" name="Selected_Contractor_Customer" >
                  <option value="0">انتخاب کنید</option>
                  <option *ngFor="let item of DataList_Contractor_Customer" [value]="item.id">{{item.title}}</option>
                </select>
              </div>

              <div class="form-group col-md-3" *ngIf="!canAnswerSecond">
                <label for="exampleInputEmail1">پیمانکار </label>
                <input disabled type="text" class="form-control" value="{{Selected_Contractor.title}} - {{Selected_Contractor_Customer.title}}" >
              </div>

              <div class="form-group col-md-3">
                <label for="exampleInputEmail1"> تاریخ ثبت بررسی ثانویه </label>
                <input disabled type="text" class="form-control" value="{{UserDateTimeSecond}}  - {{UserUserNameSecond}}" >
              </div>
            </div>

          </div>


          <div *ngIf="inner_DeviceBehfa.id>0 && UserUserNameSecond && second_answer!=false" >

            <br/>
            <hr/>
            <br/>

            <div class="row" >
              <div class="form-group col-md-4">
                <label for="exampleInputEmail1"> شماره تماس </label>
                <input  type="text" [disabled]="!canAnswerThird" class="form-control" placeholder="اینجا تایپ کنید ..." [(ngModel)]="third_phone" name="third_phone" >
              </div>

              <div class="form-group col-md-4" *ngIf="canAnswerThird" >
                <label for="exampleInputEmail1"> هزینه </label>
                <input  type="number" class="form-control" placeholder="اینجا تایپ کنید ..."  [(ngModel)]="third_price2" name="third_price2" >
              </div>
              <div class="form-group col-md-4" *ngIf="!canAnswerThird" >
                <label for="exampleInputEmail1"> هزینه </label>
                <input disabled type="text" class="form-control" value="{{third_price}}" >
              </div>

              <div class="form-group col-md-4" *ngIf="canAnswerThird">
                <label for="exampleInputEmail1">واحد</label>
                <select class="custom-select" [(ngModel)]="Selected_Money.id" name="Selected_MoneyId" >
                  <option value="0">انتخاب کنید</option>
                  <option *ngFor="let item of DataList_Money" [value]="item.id">{{item.title}}</option>
                </select>
              </div>

              <div class="form-group col-md-4" *ngIf="!canAnswerThird">
                <label for="exampleInputEmail1">واحد</label>
                <input disabled type="text" class="form-control" value="{{Selected_Money.title}}" >
              </div>

            </div>

            <div class="row" >
              <div class="form-group col-md-12">
                <label for="exampleInputEmail1"> خدمات و توصیه‌های ارائه شده تعمیرکننده  </label>
                <textarea  type="text" [disabled]="!canAnswerThird" name="third_dsc" [(ngModel)]="third_dsc" class="form-control" placeholder="اینجا تایپ کنید ..." ></textarea>
              </div>
            </div>

            <div class="row" *ngIf="canAnswerThird" >
              <div class="form-group col-md-12">
                <label for="exampleInputEmail1"> وضیعت تجهیز  </label>
                <select class="custom-select" [(ngModel)]="third_device_id" name="third_device_id" >
                  <option value="0">انتخاب کنید</option>
                  <option value="1">فعال</option>
                  <option value="2">غیر فعال</option>
                  <option value="4">در حال کالیبراسیون</option>
                  <option value="5">غیر فعال دائم</option>
                </select>
              </div>
            </div>

          </div>

          <br/>
          <hr/>
          <br/>


        </div>

      </form>

      <br/>
      <br/>

      <button *ngIf="!InProccessing && canEditMainForm && Data_Seleted_DeviceBehfa_Record.id>0" (click)="onSubmit()" type="button"  class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
      <br/>
      <br/>

      <button *ngIf="!InProccessing && canAnswerFirst" (click)="PostAnswerFirst(1)" type="button"  class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> تایید بررسی اولیه </button>
      <button *ngIf="!InProccessing && canAnswerFirst" (click)="PostAnswerFirst(0)" type="button"  class="btn btn-danger" style="margin-left: 5px;"><i class="fa  fa-times-rectangle"></i> عدم تایید بررسی اولیه </button>


      <button *ngIf="!InProccessing && canAnswerSecond && UserUserNameFirst" (click)="PostAnswerSecond(1)" type="button"  class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> تایید بررسی ثانویه </button>
      <button *ngIf="!InProccessing && canAnswerSecond && UserUserNameFirst" (click)="PostAnswerSecond(0)" type="button"  class="btn btn-danger" style="margin-left: 5px;"><i class="fa  fa-times-rectangle"></i> عدم تایید بررسی ثانویه </button>

      <button *ngIf="!InProccessing && canAnswerThird && UserUserNameSecond" (click)="PostAnswerThird()" type="button"  class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> بازگشت دستگاه </button>


      <br/>
      <br/>

      <button (click)="OnSet_DeviceBehfaRepair()" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت </button>

  </div>
</div>


<ng-template #templateDeviceBehfa>
  <div class="modal-header">
    <h4 class="modal-title pull-left">لیست اطلاعات تجهیزات بهفا </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_DeviceBehfa.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> کلید واژه </label>
          <input type="text" class="form-control" (keyup)="ReadData_DeviceBehfa_KeySearch()"
            [(ngModel)]="Search_Code_DeviceBehfa_Table" placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>شناسه سیستم</th>
              <th>Description</th>
              <th>Manufacturer</th>
              <th>Model</th>
              <th>Code BEHFA</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_DeviceBehfa
            | paginate
                    : {
                        id: 'DataList_DeviceBehfa',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_DeviceBehfa).length
                      }">
              <td>{{DataList_DeviceBehfa.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td class="EnglishClm">{{item.description}}</td>
              <td class="EnglishClm">{{item.manufacturer}}</td>
              <td class="EnglishClm">{{item.model}}</td>
              <td class="EnglishClm">{{item.codeBEHFA}}</td>
              <td (click)="Set_Selected_DeviceBehfa_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="Procssing_DeviceBehfa" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!Procssing_DeviceBehfa" type="button" (click)="ReadData_DeviceBehfa()" class="btn btn-info"
      style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_DeviceBehfa.hide()">بستن</button>
  </div>
</ng-template>


<ng-template #templateImage>
  <div class="modal-header">
     <h4 class="modal-title pull-left"> نمایش عکس </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Image.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-body" style="text-align: center;">
    <img  style="max-width: 350px;" src="{{BaseUrl}}File/DeviceBehfaRepair/{{ModalimageUrl}}"/>
  </div>
  <div class="modal-footer">
    <a class="dropdown-item" target="_blank" href="{{BaseUrl}}File/DeviceBehfaRepair/{{ModalimageUrl}}"   ><i class="fa fa-download"></i> دانلود </a>
     <button type="button" class="btn btn-danger" (click)="modalRef_Image.hide()">بستن</button>
  </div>
</ng-template>
